import _routes, { LESSON_CATEGORY as _LESSON_CATEGORY } from './routes';
import WritingAssignment from './component';

export const routes = _routes;
export const LESSON_CATEGORY = _LESSON_CATEGORY;
export default WritingAssignment;



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/index.js